import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'What type of diabetes do you have?',
    field: 'diabetesType',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'type_1',
          value: 'Type 1'
        },
        {
          key: 'type_2',
          value: 'Type 2'
        },
        {
          key: 'LADA/MODY',
          value: 'LADA or MODY'
        },
        {
          key: 'type_3c',
          value: 'Type 3c'
        },
        {
          key: 'gestational_diabetes',
          value: 'Gestational Diabetes'
        },
        {
          key: 'prediabetes',
          value: 'Prediabetes'
        },
        {
          key: 'no_diabetes',
          value: "I don't have diabetes"
        }
      ]
    }
  },
  {
    label: 'How do you administer insulin?',
    field: 'insulinAdminister',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'insulin_pump',
          value: 'Insulin Pump'
        },
        {
          key: 'manual_injections',
          value: 'Manual Injections'
        },
        {
          key: 'no_take',
          value: "I don't take insulin"
        }
      ]
    }
  },
  {
    label: 'Which insulin pump system you currently use?',
    field: 'insulinPumpType',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'omnipod',
          value: 'Omnipod'
        },
        {
          key: 'tandem',
          value: 'Tandem'
        },
        {
          key: 'medtronic',
          value: 'Medtronic'
        },
        {
          key: 'other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Where do you get your pump supplies currently',
    field: 'pumpSupplies',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'direct',
          value: 'Direct from the pump brand'
        },
        {
          key: 'diabetes_express',
          value: 'Diabetes Express'
        },
        {
          key: 'diabetes_depot',
          value: 'Diabetes Depot'
        },
        {
          key: 'other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Do you have any other health conditions we should know about',
    field: 'healthConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'HIV/ADIS',
          value: 'HIV or AIDS'
        },
        {
          key: 'blood_pressure',
          value: 'High blood pressure'
        },
        {
          key: 'BPH',
          value: 'Enlarged prostate / BPH'
        },
        {
          key: 'heart_disease',
          value: 'Heart disease'
        },
        {
          key: 'irregular_heart_beat',
          value: 'Irregular heart beat'
        },
        {
          key: 'thyroid_condition',
          value: 'Thyroid condition'
        },
        {
          key: 'cancer',
          value: 'Cancer'
        },
        {
          key: 'anxiety/depression',
          value: 'Anxiety / Depression'
        },
        {
          key: 'no_other_conditions',
          value: "I don't have other conditions"
        },
        {
          key: 'other',
          value: 'Other',
          answer: {
            label: 'Please list all other health conditions',
            type: 'text_list',
            inputPlaceholder: 'Health condition'
          }
        }
      ]
    }
  },
  {
    label: 'Do you have any medical allergies?',
    field: 'medicalAllergies',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'penicillin',
          value: 'Penicillin'
        },
        {
          key: 'sulfa_drugs',
          value: 'Sulfa drugs'
        },
        {
          key: 'aspirin',
          value: 'Aspirin'
        },
        {
          key: 'codeine',
          value: 'Codeine'
        },
        {
          key: 'latex',
          value: 'Latex'
        },
        {
          key: 'other',
          value: 'Other',
          answer: {
            label: 'Please list all your medical allergies',
            type: 'text_list',
            inputPlaceholder: 'Medical allergy'
          }
        },
        {
          key: 'no_medical_allergies',
          value: "I don't any medical allergies"
        }
      ]
    }
  },
  {
    label: 'Are you currently taking any medications?',
    field: 'endorMedications',
    type: 'polar_check',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Please list any current medications you are taking (prescription or non-prescription), including dosage.',
          type: 'text_list',
          inputPlaceholder: 'Medication Name'
        }
      ]
    }
  },
  {
    label: 'Are you currently taking any supplements?',
    field: 'endorSupplements',
    type: 'polar_check',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Please list any current supplements you are taking.',
          type: 'text_list',
          inputPlaceholder: 'Supplement name'
        }
      ]
    }
  },
  {
    label: 'What is your current gender identity?',
    field: 'currentGenderIdentity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'man',
          value: 'Man'
        },
        {
          key: 'woman',
          value: 'Woman'
        },
        {
          key: 'non_binary',
          value: 'Non-binary / Non conforming'
        },
        {
          key: 'prefer_not_to_respond',
          value: 'Prefer not to respond'
        }
      ]
    }
  },
  {
    label: 'What is your sex at birth?',
    field: 'sexAtBirth',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'male',
          value: 'Male'
        },
        {
          key: 'female',
          value: 'Female'
        },
        {
          key: 'intersex',
          value: 'Intersex'
        }
      ]
    }
  }
];

export default questionsModels;
